import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-component-with-header',
  templateUrl: './component-with-header-batch.component.html',
  styleUrls: ['./component-with-header-batch.component.css']
})
export class ComponentWithHeaderBatchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
